import React, { createContext, useContext, useState } from 'react';
import { Space } from '@risk-management/shared';

interface SpaceContextValue {
  currentSpace: Space | null;
  setCurrentSpace: (space: Space | null) => void;
  savedSpaceId: string | null;
}

const SpaceContext = createContext<SpaceContextValue | undefined>(undefined);

export const SpaceProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [currentSpace, setCurrentSpaceState] = useState<Space | null>(null);
  const [savedSpaceId] = useState<string | null>(() => {
    // Load saved space ID immediately on mount
    return localStorage.getItem('currentSpaceId');
  });

  const setCurrentSpace = (space: Space | null) => {
    setCurrentSpaceState(space);
    if (space) {
      localStorage.setItem('currentSpaceId', space.id);
    } else {
      localStorage.removeItem('currentSpaceId');
    }
  };

  return (
    <SpaceContext.Provider
      value={{ currentSpace, setCurrentSpace, savedSpaceId }}
    >
      {children}
    </SpaceContext.Provider>
  );
};

export const useSpace = () => {
  const context = useContext(SpaceContext);
  if (!context) {
    throw new Error('useSpace must be used within SpaceProvider');
  }
  return context;
};
